import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const resource = {
    namespaced: true,
    state: {
        categories: [],
        webFormStates: [],
        communes: [],
        cadhFormStates: [],
        paymentStates: [],
        languages: [],
        communicationTypes: [],
        professions: [],
        currencies: [],
        quebecCategories: []
    },
    mutations: {
        setCategories(state, value) {
            state.categories = value
        },
        setQuebecCategories(state, value) {
            state.quebecCategories = value
        },
        setWebFormStates(state, value) {
            state.webFormStates = value
        },
        setCadhFormStates(state, value) {
            state.cadhFormStates = value
        },
        setPaymentStates(state, value) {
            state.paymentStates = value
        },
        setCommunes(state, value) {
            state.communes = value
        },
        setLanguages(state, value) {
            state.languages = value
        },
        setCommunicationTypes(state, value) {
            state.communicationTypes = value
        },
        setProfessions(state, value) {
            state.professions = value
        },
        setCurrencies(state, value) {
            state.currencies = value
        }
    },
    actions: {
        fetchCategories({ commit }) {
            Vue.prototype.$http.get('resource/categories').then(res => {
                commit('setCategories', res.body.data.categories)
            })
        },
        fetchQuebecCategories({ commit }, accountId) {
            Vue.prototype.$http.get('resource/quebec-categories/' + accountId).then(res => {
                commit('setQuebecCategories', res.body.data.categories)
            })
        },
        fetchAllCategories({ commit }) {
            Vue.prototype.$http.get('resource/categories/all').then(res => {
                commit('setCategories', res.body.data.categories)
            })
        },
        fetchWebFormStates({ commit }, account) {
            let tisType = null

            if(account !== null && account !== undefined) {
                tisType = account.tis_type.code
            }

            Vue.prototype.$http.get('resource/web-form/states').then(res => {
                let availableStates = ['NOT_SENT', 'SENT', 'ANSWERED', 'WITHOUT_EMAIL',
                    'WITHOUT_WEB_FORM', 'TREATED', 'DRAFT', 'OPENED_FORM']

                if(tisType === 'APIDAE') {
                    availableStates.push('SENT_APIDAE')
                } else if(tisType === 'TOURINSOFT') {
                    availableStates.push('SENT_TOURINSOFT')
                }

                let states = res.body.data.filter(state => {
                    return availableStates.includes(state.code)
                })

                states.sort((a, b) => a.label.localeCompare(b.label, 'fr', { sensitivity: 'base' }))

                commit('setWebFormStates', states)
            })
        },
        fetchCadhFormStates({ commit }) {
            Vue.prototype.$http.get('resource/cadh-form-states').then(res => {
                let states = res.body.data
                states.sort((a, b) => a.label.localeCompare(b.label, 'fr', { sensitivity: 'base' }))
                commit('setCadhFormStates', states)
            })
        },
        fetchPaymentStates({ commit }) {
            Vue.prototype.$http.get('resource/payment-states').then(res => {
                commit('setPaymentStates', res.body.data)
            })
        },
        fetchCommunes({ commit }, search = '') {
            let payload = {
                search: search
            }

            return Vue.prototype.$http.post('resource/communes', payload).then(res => {
                let communes = res.body.data.communes

                communes.map(commune => {
                    commune.label = commune.name + ' (' + commune.code + ')'
                })
                commit('setCommunes', communes)
            })
        },
        fetchLanguages({ commit }) {
            Vue.prototype.$http.get('resource/languages').then(res => {
                commit('setLanguages', res.body.data.languages)
            })
        },
        fetchCommunicationTypes({ commit }) {
            Vue.prototype.$http.get('resource/communication-types').then(res => {
                commit('setCommunicationTypes', res.body.data.contacts)
            })
        },
        fetchProfessions({ commit }) {
            Vue.prototype.$http.get('resource/professions').then(res => {
                commit('setProfessions', res.body.data.professions)
            })
        },
        fetchCurrencies({ commit }) {
            Vue.prototype.$http.get('resource/currencies').then(res => {
                commit('setCurrencies', res.body.data.currencies)
            })
        },
    }
}

export default resource